// extracted by mini-css-extract-plugin
export default {"root":"section-header_root__9F1d7","SectionTitle":"section-header_SectionTitle__H9O61"};